<template>
    <v-container class="pt-0">

        <v-row>
            <v-col cols="12" class="text-left px-0 pt-0">
                <!--
                <v-skeleton-loader
                v-if="loading"
                class="mx-auto mt-2"
                max-width="95%"
                type="image"
                ></v-skeleton-loader>

                <v-skeleton-loader
                v-if="loading"
                class="mx-auto mt-2"
                max-width="95%"
                type="image"
                ></v-skeleton-loader>

                <v-skeleton-loader
                v-if="loading"
                class="mx-auto mt-2"
                max-width="95%"
                type="image"
                ></v-skeleton-loader>
                -->
                                
                <div id="holder">
                </div>
                
            </v-col>
        </v-row>


    </v-container>
</template>

<script>
    import store from '@/store/index'
    import { categorias_api } from '@/api/categorias';

    export default {
        name: 'ComercioPDF',
        data () {
            return {
                comercioID: this.$store.state.comercioElegidoID,
                loading: true,
                loaded: false,
            }
        },
        components: {
        },
        mounted() {
            categorias_api.getCategorias(this.comercioID)
            .then( res => {
                if(res[0] === 'pdf') {
                    this.renderPDF(res[1], document.getElementById('holder'));
                    
                }
            });

        },
        methods: {
            renderPDF: function (url, canvasContainer) {

                function renderPage(page) {
                    var viewport = page.getViewport(1);
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    var renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };
                    
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    canvasContainer.appendChild(canvas);
                    
                    page.render(renderContext);
                }
                
                function renderPages(pdfDoc) {
                    
                    for(var num = 1; num <= pdfDoc.numPages; num++) 
                        pdfDoc.getPage(num).then(renderPage);
                    

                    //setTimeout(this.loading = false, 3000);
                }

                pdfjsLib.disableWorker = true;
                pdfjsLib.getDocument(url).then(renderPages);

                
                //setTimeout(this.loaded = true, 3000);

            },
           
        }
    }
</script>

<style>
canvas {
    max-width:100%
}
</style>